import { axiosHrClient } from '../plugins/axios'

const user = {
  namespaced: true,

  actions: {
    getSystemMenus(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrportal/employees/${guid}/menusystems/1/programcatelogs/13`
          )
          const list = res.data.data.map(item => {
            const obj = {}
            obj.title = item.menuInSystemFullNameTha
            obj.menus = item.data.map(subItem => {
              return {
                name: subItem.menuInSystemFullNameTha,
                programItemMenuID: subItem.programItemMenuID,
                itemPath: subItem.menuInSystemPath,
                otherSystem: subItem.otherSystem
              }
            })
            return obj
          })
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },

    getInfo(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hr/employeeinfo/${guid}`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getPersonalInfo(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/personalinfo`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getCurrentEducations(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/educations/current`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getRecruitEducations(ctx, guid) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/employees/${guid}/educations/recruit`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getBloodTypes() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/bloodtypes`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    putPersonalInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.put(
            `/hr/employees/${payload.EmployeeId}/personalinfo`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default user
